import { fromJS } from 'immutable'
import {
  STANDARD_PRICE_GET_REQUEST,
  STANDARD_PRICE_GET_SUCCESS,
  STANDARD_PRICE_GET_FAILURE,
  STANDARD_PRICE_GET_RESET,
} from './../../constants'

const init = fromJS({
  isFetching: false,
  isAuthenticated: localStorage.getItem('access_token') !== null,
  redirect: false,
})

export default (state = init, action) => {
  switch (action.type) {
    case STANDARD_PRICE_GET_REQUEST:
      return state
        .set('isFetching', false)
    case STANDARD_PRICE_GET_SUCCESS:
      return state
        .set('standardPrice', fromJS(action.payload.standard_prices))
        .set('isFetching', false)
    case STANDARD_PRICE_GET_FAILURE:
      if (action.payload.status === 401) {
        return state
          .set('redirect', true)
      }
      return state
        .set('isFetching', false)
    case STANDARD_PRICE_GET_RESET:
      return state
        .delete('standardPrice')
        .set('isFetching', false)
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/standard-price/standard-price-get-reducer.js